<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[
                { text: 'Home', disable: false, href: '/#/' },
                {
                    text: 'Growth Tasks',
                    disable: false,
                    href: '/#/growthtasks'
                },
                { text: growthTask.rawId, disabled: true }
            ]"
            divider="/"
        ></v-breadcrumbs>

        <GrowthTaskDetailComponent
            :growthTaskNodeId="$route.params.id"
            v-on:item-fetched="onGrowthTaskFecthed"
            v-on:item-deleted="onGrowthTaskDeleted"
        ></GrowthTaskDetailComponent>
    </v-container>
</template>

<script>
import GrowthTaskDetailComponent from "@/components/growth/GrowthTaskDetailComponent.vue";

export default {
    name: "growthtask-detail-page",
    components: {
        GrowthTaskDetailComponent
    },

    data() {
        return {
            growthTask: {
                plant: {
                    id: null,
                    name: null,
                    growthTaskPhaseSet: {},
                    growthTaskInventoryLogSet: {}
                }
            }
        };
    },
    computed: {},
    watch: {},
    created() {},
    methods: {
        onGrowthTaskFecthed(response) {
            this.growthTask = response;
        },
        onGrowthTaskDeleted() {
            // redirect to products list page
            this.$router.push("/growthtasks");
        }
    }
};
</script>